import { useSyncExternalStore } from "react";
import { CLINICIAN_PORTAL_NAVIGATION_EVENT } from "../routing/portalRoutes";
import { sessionLocation } from "../utils/clientSessionNavigation";

function subscribe(onChange: () => void) {
  window.addEventListener("popstate", onChange);
  window.addEventListener(CLINICIAN_PORTAL_NAVIGATION_EVENT, onChange);
  return () => {
    window.removeEventListener("popstate", onChange);
    window.removeEventListener(CLINICIAN_PORTAL_NAVIGATION_EVENT, onChange);
  };
}
const snapshot = () => window.location.search;
export function useSessionLocation() {
  const search = useSyncExternalStore(subscribe, snapshot);
  return { search, ...sessionLocation(search) };
}
